import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { TadManagerConfigListStore } from "../../store/TadManagerConfigListStore";

type TadManagerConfigListDialogsProps = {
  store: TadManagerConfigListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de TadManagerConfig.
 * Separado para mantener TadManagerConfigListPage más limpio.
 */
export const TadManagerConfigListDialogs: React.FC<TadManagerConfigListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
